import axios from 'axios'

export default {
  get (code) {
    return axios
      .get(`/api/balance?giftcard=${code}`)
      .then(res => res.data)
  }
}
